import { b2c } from "../../constants/actionTypes";

const INITIAL_STATE = {
  plansList: [],
  retrievePlanList: [],
  planMapUpdateData: {},
  planItem: {},
  planDelete: {},
  freeTrialTemplate: {},
  errorData: {},
  catalogListB2c: {},
  b2cListItem: {},
  latestPurchasesB2C: {},
  b2cTrendingLabs: {},
  b2cVmLabsList: {},
  addToCart: {},
  addToCartError: {},
  userCartDetails: {},
  deleteItemCart: {},
  checkoutData: {},
  paymentCallbackData: {},
  paymentReceiptData: {},
  paymentReceiptError: {},
  userCartError: {},
  myLabsB2CLoader: false,
  discountData: {},
};

const b2cReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case b2c?.SUCCESS_GET_PLAN_LIST:
      return {
        ...state,
        plansList: action?.payload,
      };

    case b2c.RESET_RETRIEVE_PLAN_LIST:
      return {
        ...state,
        retrievePlanList: [],
      };

    case b2c?.SUCCESS_RETRIEVE_PLAN_LIST:
      return {
        ...state,
        retrievePlanList: action?.payload,
      };

    case b2c.SUCCESS_UPDATE_CATALOG_B2C_PLAN_MAP:
      return {
        ...state,
        planMapUpdateData: action?.payload,
        retrievePlanList: [],
      };

    case b2c.SUCCESS_FREE_TRIAL_TEMPLATE:
      return {
        ...state,
        freeTrialTemplate: action?.payload,
      };

    case b2c.SUCCESS_B2C_CATALOGS_LIST:
      return {
        ...state,
        catalogListB2c: action?.payload?.data,
      };

    case b2c.CLEAR_B2C_CATALOGS_LIST:
      return {
        ...state,
        catalogListB2c: [],
      };

    case b2c.SUCCESS_RETRIVE_B2C_CATALOG_LIST:
      return {
        ...state,
        b2cListItem: action?.payload,
      };

    case b2c.CLEAR_RETRIVE_B2C_CATALOG_LIST:
      return {
        ...state,
        b2cListItem: {},
      };

    case b2c.SUCCESS_B2C_TRENDING_LABS:
      return {
        ...state,
        b2cTrendingLabs: action?.payload?.data,
      };

    case b2c?.SUCCESS_SET_PLAN_LIST:
    case b2c?.SUCCESS_DELETE_PLAN:
    case b2c?.SUCCESS_UPDATE_PLAN:
      return {
        ...state,
        planItem: action?.payload,
      };

    case b2c?.SUCCESS_GET_LATEST_PURCHASES:
      return {
        ...state,
        latestPurchasesB2C: action?.payload?.data,
      };

    case b2c?.SUCCESS_B2C_VM_LABS_LIST:
      return {
        ...state,
        b2cVmLabsList: action?.payload?.data,
      };

    case b2c?.SUCCESS_ADD_LAB_INTO_CART:
      return {
        ...state,
        addToCart: action?.payload,
      };

    case b2c?.CLEAR_ADD_LAB_INTO_CART:
      return {
        ...state,
        addToCart: "",
      };

    case b2c?.SUCCESS_USER_CART_DETAILS:
      return {
        ...state,
        userCartDetails: action?.payload,
      };

    case b2c?.SUCCESS_DELETE_ITEM_TO_CART:
      return {
        ...state,
        deleteItemCart: action?.payload,
      };

    case b2c?.SUCCESS_B2C_CHECKOUT:
      return {
        ...state,
        checkoutData: action?.payload,
      };

    case b2c?.CLEAR_B2C_CHECKOUT:
      return {
        ...state,
        checkoutData: "",
      };

    case b2c?.SUCCESS_PAYMENT_CALLBACK:
      return {
        ...state,
        paymentCallbackData: action?.payload,
      };

    case b2c?.SUCCESS_APPLY_DISCOUNT:
      return {
        ...state,
        discountData: action?.payload,
      };

    case b2c?.CLEAR_PAYMENT_CALLBACK:
      return {
        ...state,
        paymentCallbackData: "",
      };

    case b2c?.SUCCESS_PAYMENT_RECEIPT:
      return {
        ...state,
        paymentReceiptData: action?.payload,
      };

    case b2c?.CLEAR_PAYMENT_RECEIPT:
      return {
        ...state,
        paymentReceiptData: "",
      };

    case b2c?.ERROR_PAYMENT_RECEIPT:
      return {
        ...state,
        paymentReceiptError: action?.payload,
      };

    case b2c?.ERROR_USER_CART_DETAILS:
    case b2c?.ERROR_DELETE_ITEM_TO_CART:
    case b2c?.ERROR_B2C_CHECKOUT:
    case b2c?.ERROR_PAYMENT_CALLBACK:
      return {
        ...state,
        userCartError: action?.payload,
      };

    case b2c?.ERROR_ADD_LAB_INTO_CART:
      return {
        ...state,
        addToCartError: action?.payload,
      };

    case b2c?.CLEAR_ADD_LAB_INTO_CART_ERROR:
      return {
        ...state,
        addToCartError: "",
      };

    case b2c?.CLEAR_PLAN_ITEM:
      return {
        ...state,
        planItem: "",
      };
    case b2c.LOADER_B2C_GET_REQUEST:
    case b2c.LOADER_B2C_GET_SUCCESS:
      return {
        ...state,
        myLabsB2CLoader: action.data,
      };

    case b2c.SET_B2C_WEB_SOCKET_DATA:
      let tempLabList = state.b2cVmLabsList;
      tempLabList?.results.forEach((element) => {
        if (action?.data?.payload && element?.id === action?.data?.payload?.vm) {
          element.vm_state = action?.data?.payload?.vm_state;
        }
      });
      return {
        ...state,
        b2cVmLabsList: tempLabList,
      };

    case b2c?.ERROR_GET_PLAN_LIST:
    case b2c?.ERROR_RETRIEVE_PLAN_LIST:
    case b2c?.ERROR_UPDATE_CATALOG_B2C_PLAN_MAP:
    case b2c?.ERROR_SET_PLAN_LIST:
    case b2c?.ERROR_DELETE_PLAN:
    case b2c?.ERROR_UPDATE_PLAN:
    case b2c?.ERROR_FREE_TRIAL_TEMPLATE:
    case b2c?.ERROR_B2C_CATALOGS_LIST:
    case b2c?.ERROR_GET_LATEST_PURCHASES:
    case b2c?.ERROR_B2C_TRENDING_LABS:
    case b2c?.ERROR_RETRIVE_B2C_CATALOG_LIST:
    case b2c?.ERROR_B2C_VM_LABS_LIST:
    case b2c?.ERROR_APPLY_DISCOUNT:
      return {
        ...state,
        errorData: action?.payload,
      };

    default:
      return state;
  }
};

export default b2cReducer;
